/* ============================================================
   PAPA KING — Interactive script
   ============================================================ */
(function () {
  "use strict";

  /* ---------- 18+ Age verification ---------- */
  var ageGate = document.getElementById("ageGate");
  if (ageGate) {
    if (localStorage.getItem("pk_adult") === "yes") {
      ageGate.classList.add("age-gate--hidden");
    } else {
      document.body.style.overflow = "hidden";
    }
    document.getElementById("ageYes").addEventListener("click", function () {
      localStorage.setItem("pk_adult", "yes");
      ageGate.classList.add("age-gate--hidden");
      document.body.style.overflow = "";
    });
    document.getElementById("ageNo").addEventListener("click", function () {
      window.location.href = "https://www.baidu.com";
    });
  }

  /* ---------- Mobile menu ---------- */
  var burger = document.getElementById("burger");
  var links = document.querySelector(".nav__links");
  if (burger && links) {
    burger.addEventListener("click", function () {
      links.classList.toggle("nav__links--open");
    });
    links.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        links.classList.remove("nav__links--open");
      });
    });
  }

  /* ---------- Scroll entrance animation ---------- */
  var revealEls = document.querySelectorAll(".card, .feature, .flavor, .section__head, .contact__inner");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal--visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) {
      el.classList.add("reveal");
      io.observe(el);
    });
  }

  /* ---------- Placeholder form ---------- */
  var form = document.getElementById("notifyForm");
  var hint = document.getElementById("formHint");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = form.querySelector("input[name=email]").value.trim();
      if (!email || email.indexOf("@") < 0) return;
      hint.textContent = "✅ Received " + email + ". It will sync to the customer list after Shopify is connected";
      hint.style.color = "#7cff4f";
      form.reset();
    });
  }
})();


// PAPA_KING_ENGLISH_TEXT_PATCH
(function () {
  const replacements = new Map([
    ["\u4e3b\u9875", "Home"],
    ["\u4ea7\u54c1\u76ee\u5f55", "Catalog"],
    ["\u8054\u7cfb\u6211\u4eec", "Contact Us"],
    ["\u6211\u7684\u5546\u5e97", "PAPA KING"],
    ["\u641c\u7d22", "Search"],
    ["\u8d2d\u7269\u8f66", "Cart"],
    ["\u8d26\u6237", "Account"],
    ["\u767b\u5f55", "Log in"],
    ["\u6ce8\u518c", "Sign up"],
    ["\u6240\u6709\u4ea7\u54c1", "All Products"],
    ["\u4ea7\u54c1", "Products"],
    ["\u8054\u7cfb", "Contact"],
  ]);

  function replaceText(value) {
    let next = value;
    for (const [source, target] of replacements) {
      next = next.split(source).join(target);
    }
    return next;
  }

  function translateNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const next = replaceText(node.nodeValue || "");
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const element = node;
    for (const attr of ["aria-label", "title", "placeholder", "alt"]) {
      if (element.hasAttribute && element.hasAttribute(attr)) {
        const value = element.getAttribute(attr);
        const next = replaceText(value || "");
        if (next !== value) element.setAttribute(attr, next);
      }
    }
  }

  function translateTree(root) {
    translateNode(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node;
    while ((node = walker.nextNode())) translateNode(node);
    document.title = replaceText(document.title);
  }

  function run() {
    translateTree(document.body);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) translateTree(node);
      if (mutation.type === "characterData") translateNode(mutation.target);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
